import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe2ae3bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-page" }
const _hoisted_2 = { class: "top-cont" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content container" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "desc" }
const _hoisted_7 = {
  key: 0,
  class: "data-deletion"
}
const _hoisted_8 = { class: "ttl" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<p data-v-fe2ae3bc> At Jortsoft, we take user privacy seriously. If you would like to request the deletion of your data associated with the Screamer Cube app, please follow these steps: </p><br data-v-fe2ae3bc><p data-v-fe2ae3bc>1. Send an email to <a href=\"mailto: contact@jortsoft.com\" data-v-fe2ae3bc>contact@jortsoft.com</a> with the subject line: &quot;Data Deletion Request.</p><p data-v-fe2ae3bc>2. Include the following information in your email:</p><p data-v-fe2ae3bc>Your full name</p><p data-v-fe2ae3bc>Any relevant details related to your data request</p><p data-v-fe2ae3bc>3. Once your request is received, we will process it within 30 days.</p><br data-v-fe2ae3bc><b data-v-fe2ae3bc>What Data Is Deleted:</b><p data-v-fe2ae3bc>Device identifiers used for Unity Ads</p><p data-v-fe2ae3bc>Any other collected data (if applicable).</p><br data-v-fe2ae3bc><b data-v-fe2ae3bc>Retention Periods:</b><p data-v-fe2ae3bc>We do not retain data beyond the time required for app functionality or to comply with legal requirements.</p>", 14)
const _hoisted_23 = { class: "vid center" }
const _hoisted_24 = {
  key: 0,
  class: "not-trailer"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "bottom-cont center" }
const _hoisted_27 = { class: "swiper-container" }
const _hoisted_28 = { class: "but-cont" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "28",
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1.39343 12.0659C0.881368 12.5786 0.59375 13.2736 0.59375 13.9982C0.59375 14.7228 0.881368 15.4178 1.39343 15.9305L11.7038 26.2463C12.2168 26.7593 12.9125 27.0475 13.638 27.0475C14.3634 27.0475 15.0591 26.7593 15.5721 26.2463C16.085 25.7334 16.3732 25.0377 16.3732 24.3122C16.3732 23.5868 16.085 22.8911 15.5721 22.3781L9.92832 16.7325L30.9557 16.7325C31.6809 16.7325 32.3764 16.4445 32.8892 15.9317C33.402 15.4189 33.69 14.7234 33.69 13.9982C33.69 13.273 33.402 12.5775 32.8892 12.0647C32.3764 11.5519 31.6809 11.2638 30.9557 11.2638L9.92832 11.2638L15.5721 5.62005C15.8261 5.36606 16.0275 5.06453 16.165 4.73267C16.3025 4.40082 16.3732 4.04513 16.3732 3.68594C16.3732 3.32674 16.3025 2.97106 16.165 2.6392C16.0275 2.30734 15.8261 2.00581 15.5721 1.75182C15.3181 1.49783 15.0165 1.29635 14.6847 1.15889C14.3528 1.02143 13.9972 0.950684 13.638 0.950684C13.2788 0.950684 12.9231 1.02143 12.5912 1.15889C12.2594 1.29635 11.9578 1.49783 11.7038 1.75182L1.39343 12.0659Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "28",
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M32.8904 15.9323C33.4024 15.4196 33.6901 14.7246 33.6901 14C33.6901 13.2754 33.4024 12.5804 32.8904 12.0677L22.58 1.75182C22.067 1.23886 21.3713 0.950684 20.6459 0.950684C19.9204 0.950684 19.2247 1.23886 18.7117 1.75182C18.1988 2.26478 17.9106 2.9605 17.9106 3.68593C17.9106 4.41137 18.1988 5.10709 18.7117 5.62005L24.3555 11.2656L3.32815 11.2656C2.60295 11.2656 1.90745 11.5537 1.39466 12.0665C0.881863 12.5793 0.593777 13.2748 0.593777 14C0.593777 14.7252 0.881863 15.4207 1.39466 15.9335C1.90745 16.4463 2.60295 16.7344 3.32815 16.7344L24.3555 16.7344L18.7117 22.3781C18.4577 22.6321 18.2563 22.9336 18.1188 23.2655C17.9814 23.5974 17.9106 23.953 17.9106 24.3122C17.9106 24.6714 17.9814 25.0271 18.1188 25.359C18.2563 25.6908 18.4577 25.9924 18.7117 26.2464C18.9657 26.5003 19.2673 26.7018 19.5991 26.8393C19.931 26.9767 20.2867 27.0475 20.6459 27.0475C21.0051 27.0475 21.3607 26.9767 21.6926 26.8393C22.0244 26.7018 22.326 26.5003 22.58 26.2464L32.8904 15.9323Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "swiper-wrapper" }
const _hoisted_34 = {
  class: "abs-img",
  alt: "Galley image"
}
const _hoisted_35 = { class: "download-cont" }
const _hoisted_36 = ["href"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["href"]
const _hoisted_39 = ["src"]
const _hoisted_40 = ["href"]
const _hoisted_41 = ["src"]

import Footer from '@/components/Footer.vue';
import products from '@/jsons/products.json'
import { store } from '@/store/store';
import { ComputedRef, computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head'
import Swiper from 'swiper';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectPage',
  setup(__props) {

const Store = store();
const route = useRoute();

const mySwiper = ref();
const initSwiper = (): void => {
    mySwiper.value = new Swiper('.game-page .swiper-container', {
        // Configure Swiper options here
        slidesPerView: 1,
        speed: 800,
        loop: true,
        autoplay: {
            delay: 5000,
        },
    });
    mySwiper.value.init();
}

const currentData: ComputedRef<any> = computed(() => products.find(item => item.route == route.params.projectname))

useHead({
    title: `Jortsoft | ${currentData.value.name}`,
    meta: [
        {
            name: "description",
            content: `Jortsoft | ${currentData.value.name}`
        },
        {
            property: "og:url",
            content: Store.getDomain
        },
        {
            property: "og:type",
            content: "website"
        },
        {
            property: "og:title",
            content: `Jortsoft | ${currentData.value.name}`
        },
        {
            property: "og:description",
            content: `Jortsoft | ${currentData.value.name}`
        },
    ]
})

const switchSlider = (move: boolean): void => {
    move ? mySwiper.value.slideNext() : mySwiper.value.slidePrev();
}

onMounted(() => {
    initSwiper();
})

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "abs-img",
        src: require('@/assets/' + currentData.value.images[0]),
        alt: "Banner"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(currentData.value.name), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? currentData.value.descGEO : currentData.value.descENG), 1),
        (currentData.value.deletiondData)
          ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, "Request Data Deletion for " + _toDisplayString(currentData.value.name), 1),
              _hoisted_9
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          (!currentData.value.trailer)
            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? 'თრეილერი დაიდება მალე...' : 'Trailer soon...'), 1))
            : _createCommentVNode("", true),
          _createElementVNode("iframe", {
            class: "abs-img",
            src: currentData.value.trailer,
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
            allowfullscreen: ""
          }, null, 8, _hoisted_25)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (switchSlider(false)))
          }, _hoisted_30),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (switchSlider(true)))
          }, _hoisted_32)
        ]),
        _createElementVNode("div", _hoisted_33, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentData.value.images, (img, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "swiper-slide img",
              key: index
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_34, null, 512), [
                [_directive_lazy, { src: require('@/assets/' + img), loading: require('@/assets/loading.gif') }]
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        (currentData.value.itchio)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: currentData.value.itchio,
              target: "__blank"
            }, [
              _createElementVNode("img", {
                src: require('@/assets/itchio.png'),
                alt: "Download image"
              }, null, 8, _hoisted_37)
            ], 8, _hoisted_36))
          : _createCommentVNode("", true),
        (currentData.value.playstore)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: currentData.value.playstore,
              target: "__blank"
            }, [
              _createElementVNode("img", {
                src: require('@/assets/playstore.png'),
                alt: "Download image"
              }, null, 8, _hoisted_39)
            ], 8, _hoisted_38))
          : _createCommentVNode("", true),
        (currentData.value.steam)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: currentData.value.steam,
              target: "__blank"
            }, [
              _createElementVNode("img", {
                src: require('@/assets/steam.webp'),
                alt: "Download image"
              }, null, 8, _hoisted_41)
            ], 8, _hoisted_40))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})